import type { CSSProperties, ReactNode } from 'react'

export interface PageHeaderProps {
  overline?: string
  title: ReactNode
  /** Optional subtitle rendered below the h1. */
  subtitle?: ReactNode
  style?: CSSProperties
}

/** Left-aligned page header: overline chip + h1 + optional subtitle. */
export function PageHeader({
  overline,
  title,
  subtitle,
  style,
}: PageHeaderProps) {
  return (
    <div style={style}>
      {overline && (
        <div className="oumma-overline" style={{ marginBottom: 10 }}>
          {overline}
        </div>
      )}
      <h1
        style={{ fontSize: 'var(--text-h1)', margin: subtitle ? '0 0 8px' : 0 }}
      >
        {title}
      </h1>
      {subtitle && (
        <p style={{ color: 'var(--ink-2)', margin: 0, fontSize: 15 }}>
          {subtitle}
        </p>
      )}
    </div>
  )
}
